import React from 'react';
import { X } from 'lucide-react';

const VideoPlayer = ({ videoUrl, title, onClose }) => {
  // Extract YouTube video ID and convert to embed URL
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;
    
    // Handle various YouTube URL formats
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1]) {
        return `https://www.youtube.com/embed/${match[1]}?autoplay=1&rel=0&modestbranding=1&playsinline=1&controls=1`;
      }
    }
    
    return null;
  };

  const embedUrl = getYouTubeEmbedUrl(videoUrl);
  const isYouTube = embedUrl !== null;

  // For non-YouTube videos, show message to use YouTube
  if (!isYouTube) {
    return (
      <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={onClose}>
        <div
          className="relative w-full max-w-2xl bg-slate-900 rounded-lg overflow-hidden shadow-2xl p-8"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-50 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-all"
          >
            <X size={24} />
          </button>
          
          <div className="text-center text-white">
            <h3 className="text-xl font-bold mb-4">Video Playback Not Available</h3>
            <p className="text-slate-300 mb-2">
              Only YouTube videos are supported. Please use a YouTube URL.
            </p>
            <button
              onClick={onClose}
              className="inline-block px-6 py-3 bg-slate-700 text-white rounded-lg hover:bg-slate-600 transition-all mt-4"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4" onClick={onClose}>
      <div
        className="relative w-full max-w-6xl aspect-video bg-black rounded-lg overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full transition-all"
        >
          <X size={24} />
        </button>

        {/* YouTube iframe */}
        <iframe
          src={embedUrl}
          className="w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={title || 'Video Player'}
        />

        {/* Title */}
        {title && (
          <div className="absolute top-4 left-4 bg-black/50 text-white px-4 py-2 rounded-lg">
            <h3 className="font-bold">{title}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPlayer;
